var exports = {
  "kL": "container__41ZIrM",
  "WX": "leftControls__SWQHNN",
  "RN": "rightControls__3qxEEe",
  "lM": "starButton__6_G_iA",
  "az": "hideOnMobile__3ZXnur",
  "t7": "showOnMobile__pr_8U5",
};

module.exports = exports;
